export const VIEWED_LISTING_ID = 'viewed_listing_id'
